import { useWorkOrderRecord } from "@/app/ProDrivers/WorkOrders/Hooks/useWorkOrderRecord";
import { ModelType } from "@/gql/graphql";
import { ActivityLogFeed } from "@/app/ActivityLogs/Components/ActivityLogFeed";

export function WorkOrderActivityScreen() {
  const workOrder = useWorkOrderRecord();

  return (
    <div className="py-10">
      <ActivityLogFeed modelId={workOrder.id} modelType={ModelType.WorkOrder} />
    </div>
  );
}
